import { Button } from "reactstrap"
import ThumbnailImage from "components/Common/ThumbnailImage"
import StatusBadge from "components/Common/StatusBadge"
import LiveIndicator from "components/Common/LiveIndicator/LiveIndicator"
import ViewOnWebsite from "pages/StockPages/StockView/ViewOnWebsite"

const StockIdCell = ({ stock, openImageViewer, setImageTitle }) => {
  return (
    <div
      className="text-wrap"
      style={{
        minWidth: "5rem",
        whiteSpace: "normal",
        overflowWrap: "break-word",
      }}
    >
      {stock.stock_id}

      <div className="text-muted d-block mt-1">
        {stock.full_chassis ?? "-"}
      </div>

      <ThumbnailImage
        primaryImage={stock?.primary_image}
        images={stock?.images}
        alt="No Image"
      />

      <div className="text-muted d-block mt-1">
        <StatusBadge
          trueLabel="Published"
          falseLabel="Draft"
          trueColor="primary"
          falseColor="warning"
          value={stock.is_published}
        />
      </div>

      {stock.is_published_on_website && (
        <LiveIndicator text="Live on Website" />
      )}

      <ViewOnWebsite stock_id={stock.stock_id} />

      {stock?.auction_sheet?.url && (
        <div className="mt-1">
          <Button
            size="sm"
            color="success"
            onClick={() => {
              openImageViewer(stock.auction_sheet.url)
              setImageTitle(`Auction Sheet - ${stock.full_chassis}`)
            }}
          >
            View Auction Sheet
          </Button>
        </div>
      )}
    </div>
  )
}

export default StockIdCell
